import { render, staticRenderFns } from "./printUser.vue?vue&type=template&id=31cbcb4e&scoped=true"
import script from "./printUser.vue?vue&type=script&lang=js"
export * from "./printUser.vue?vue&type=script&lang=js"
import style0 from "./printUser.vue?vue&type=style&index=0&id=31cbcb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cbcb4e",
  null
  
)

export default component.exports